"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.plugin = exports.tezosDomainsPlugin = exports.TezosDomainPlugin = void 0;
/* eslint-disable import/no-extraneous-dependencies */
var resolvers_1 = require("./resolvers");
var w3_1 = require("./w3");
var Mapping = __importStar(require("./mapping"));
var core_js_1 = require("@web3api/core-js");
var taquito_client_1 = require("@tezos-domains/taquito-client");
var signer_1 = require("@taquito/signer");
var taquito_1 = require("@taquito/taquito");
var tzip16_1 = require("@taquito/tzip16");
var utils_1 = require("@taquito/utils");
var core_1 = require("@tezos-domains/core");
var TezosDomainPlugin = /** @class */ (function (_super) {
    __extends(TezosDomainPlugin, _super);
    function TezosDomainPlugin(_config) {
        var _a, _b;
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._connections = {};
        if (_this._config.connections) {
            _this.setConnections(_this._config.connections);
        }
        if (_this._config.defaultNetwork && ((_a = _this._config.connections) === null || _a === void 0 ? void 0 : _a[_this._config.defaultNetwork])) {
            TezosDomainPlugin.defaultNetwork = _this._config.defaultNetwork;
            TezosDomainPlugin.defaultConnection = (_b = _this._config.connections) === null || _b === void 0 ? void 0 : _b[_this._config.defaultNetwork];
        }
        return _this;
    }
    TezosDomainPlugin.manifest = function () {
        return w3_1.manifest;
    };
    TezosDomainPlugin.prototype.getModules = function (client) {
        return {
            query: (0, resolvers_1.query)(this, client),
            mutation: (0, resolvers_1.mutation)(this, client)
        };
    };
    TezosDomainPlugin.prototype.setConnections = function (connections) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.keys(connections)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var network = _c.value;
                var lowerCasedNetwork = network.toLowerCase();
                this._connections[lowerCasedNetwork] = connections[network];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // Query
    TezosDomainPlugin.prototype.resolveDomain = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domainsClient, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _a.sent();
                        if (!domainsClient.validator.validateDomainName(input.domain)) {
                            throw new Error("Address is not valid: ".concat(input.domain));
                        }
                        return [4 /*yield*/, domainsClient.resolver.resolveNameToAddress(input.domain)];
                    case 2:
                        address = _a.sent();
                        if (!address) {
                            throw new Error("Address: ".concat(address, " could not be resolved to a valid tezos address"));
                        }
                        return [2 /*return*/, address];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.resolveAddressToDomain = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domainsClient, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _a.sent();
                        return [4 /*yield*/, domainsClient.resolver.resolveAddressToName(input.address)];
                    case 2:
                        address = _a.sent();
                        if (!address) {
                            throw new Error("\n      reverse record with the specified address does not exist or \n      reverse record with the specified address does not specify a name or\n      record with the name specified by the reverse record does not exist or\n      record with the name specified by the reverse record is expired or");
                        }
                        return [2 /*return*/, address];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.resolveDomainRecords = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domainsClient, records;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _a.sent();
                        return [4 /*yield*/, domainsClient.resolver.resolveDomainRecord(input.domain)];
                    case 2:
                        records = _a.sent();
                        if (records) {
                            return [2 /*return*/, Mapping.toDomainRecords(records)];
                        }
                        return [2 /*return*/, records];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.getAcquisitionInfo = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var cost, domainsClient, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _a.sent();
                        return [4 /*yield*/, domainsClient.manager.getAcquisitionInfo(input.domain)];
                    case 2:
                        info = _a.sent();
                        if (input.duration) {
                            cost = info.calculatePrice(input.duration);
                        }
                        return [2 /*return*/, {
                                state: info.acquisitionState,
                                cost: cost
                            }];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.getSupportedTlds = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domainsClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _a.sent();
                        return [2 /*return*/, domainsClient.validator.supportedTLDs];
                }
            });
        });
    };
    // Mutations
    TezosDomainPlugin.prototype.setSignerWithSecretKeyParams = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, key, passphrase, signer, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        _b.sent();
                        _a = input.params, key = _a.key, passphrase = _a.passphrase;
                        return [4 /*yield*/, signer_1.InMemorySigner.fromSecretKey(key, passphrase)];
                    case 2:
                        signer = _b.sent();
                        this.setSigner(signer);
                        return [2 /*return*/, {
                                status: true
                            }];
                    case 3:
                        error_1 = _b.sent();
                        return [2 /*return*/, {
                                status: false,
                                error: error_1
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.setSignerWithFundraiserParams = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, email, password, mnemonic, signer, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        _b.sent();
                        _a = input.params, email = _a.email, password = _a.password, mnemonic = _a.mnemonic;
                        return [4 /*yield*/, signer_1.InMemorySigner.fromFundraiser(email, password, mnemonic)];
                    case 2:
                        signer = _b.sent();
                        this.setSigner(signer);
                        return [2 /*return*/, {
                                status: true
                            }];
                    case 3:
                        error_2 = _b.sent();
                        return [2 /*return*/, {
                                status: false,
                                error: error_2
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.updateDomainRecord = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var address, domain, owner, records, confirmation, domainsClient, _a, name, tld, domainValidationResult, domainRecords, data, key, operation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        address = input.address, domain = input.domain, owner = input.owner, records = input.records, confirmation = input.confirmation;
                        if (!(0, utils_1.validateAddress)(owner)) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: "Owner address '".concat(owner, "' is not valid")
                                }];
                        }
                        if (address && !(0, utils_1.validateAddress)(address)) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: "Address '".concat(address, "' is not valid")
                                }];
                        }
                        return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _b.sent();
                        if (!this._client.signer) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: 'Signer not available. Signer need to be set to be able to purchase a doamin'
                                }];
                        }
                        _a = __read(domain.split("."), 2), name = _a[0], tld = _a[1];
                        domainValidationResult = this.validateDomain(domainsClient, name, tld);
                        if (!domainValidationResult.status) {
                            return [2 /*return*/, domainValidationResult];
                        }
                        return [4 /*yield*/, domainsClient.resolver.resolveDomainRecord(domain)];
                    case 2:
                        domainRecords = _b.sent();
                        data = domainRecords === null || domainRecords === void 0 ? void 0 : domainRecords.data;
                        if (data == undefined) {
                            data = new core_1.RecordMetadata();
                        }
                        // @ts-ignore
                        // ignore records type being string
                        for (key in records) {
                            data.setJson(key, records[key]);
                        }
                        return [4 /*yield*/, domainsClient.manager.updateRecord({ name: domain, owner: owner, address: address, data: data })];
                    case 3:
                        operation = _b.sent();
                        return [4 /*yield*/, operation.confirmation(confirmation || undefined)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/, {
                                status: true
                            }];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.createSubDomain = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domain, subdomain, owner, confirmation, domainsClient, _a, name, tld, domainValidationResult, recordOperation, reverseRecordOperation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        domain = input.domain, subdomain = input.subdomain, owner = input.owner;
                        confirmation = input.confirmation;
                        if (!confirmation) {
                            confirmation = 5;
                        }
                        if (!(0, utils_1.validateAddress)(owner)) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: "Address '".concat(owner, "' is not valid")
                                }];
                        }
                        return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _b.sent();
                        if (!this._client.signer) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: 'Signer not available. Signer need to be set to be able to purchase a doamin'
                                }];
                        }
                        _a = __read(domain.split("."), 2), name = _a[0], tld = _a[1];
                        domainValidationResult = this.validateDomain(domainsClient, name, tld);
                        if (!domainValidationResult.status) {
                            return [2 /*return*/, domainValidationResult];
                        }
                        return [4 /*yield*/, domainsClient.manager.setChildRecord({ label: subdomain, parent: domain, owner: owner, address: owner, data: new core_1.RecordMetadata() })];
                    case 2:
                        recordOperation = _b.sent();
                        return [4 /*yield*/, recordOperation.confirmation(confirmation || undefined)];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, domainsClient.manager.claimReverseRecord({ owner: owner, name: "".concat(subdomain, ".").concat(domain) })];
                    case 4:
                        reverseRecordOperation = _b.sent();
                        return [4 /*yield*/, reverseRecordOperation.confirmation(confirmation || undefined)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, {
                                status: true
                            }];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.buyDomain = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var domain, duration, owner, confirmation, domainsClient, _a, name, tld, domainValidationResult, address, nonce, request, commitOperation, buyOperation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        domain = input.domain, duration = input.duration, owner = input.owner;
                        confirmation = input.confirmation;
                        if (!confirmation) {
                            confirmation = 5;
                        }
                        if (!(0, utils_1.validateAddress)(owner)) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: "Address '".concat(owner, "' is not valid")
                                }];
                        }
                        return [4 /*yield*/, this.getTezosDomainsClient(input.connection)];
                    case 1:
                        domainsClient = _b.sent();
                        if (!this._client.signer) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: 'Signer not available. Signer need to be set to be able to purchase a domain'
                                }];
                        }
                        _a = __read(domain.split("."), 2), name = _a[0], tld = _a[1];
                        domainValidationResult = this.validateDomain(domainsClient, name, tld);
                        if (!domainValidationResult.status) {
                            return [2 /*return*/, domainValidationResult];
                        }
                        return [4 /*yield*/, domainsClient.resolver.resolveNameToAddress("".concat(name, ".").concat(tld))];
                    case 2:
                        address = _b.sent();
                        if (address) {
                            return [2 /*return*/, {
                                    status: false,
                                    error: "Domain name '".concat(name, ".").concat(tld, "' is already taken")
                                }];
                        }
                        nonce = (0, core_1.generateNonce)();
                        request = {
                            label: name,
                            owner: owner,
                            nonce: nonce
                        };
                        return [4 /*yield*/, domainsClient.manager.commit(tld, request)];
                    case 3:
                        commitOperation = _b.sent();
                        return [4 /*yield*/, commitOperation.confirmation(confirmation)];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, domainsClient.manager.buy(tld, __assign(__assign({}, request), { duration: duration, address: owner, data: new core_1.RecordMetadata(), nonce: nonce }))];
                    case 5:
                        buyOperation = _b.sent();
                        return [4 /*yield*/, buyOperation.confirmation(confirmation)];
                    case 6:
                        _b.sent();
                        return [2 /*return*/, {
                                status: true
                            }];
                }
            });
        });
    };
    // Utils
    TezosDomainPlugin.prototype.validateDomain = function (client, name, tld) {
        if (!name) {
            return {
                status: false,
                error: "Domain name: '".concat(name, "' is not a valid name for a domain")
            };
        }
        if (!tld || !client.validator.supportedTLDs.includes(tld)) {
            return {
                status: false,
                error: "Domain TLD: '".concat(tld, "' is not valid")
            };
        }
        return {
            status: true
        };
    };
    TezosDomainPlugin.prototype.setSigner = function (signer) {
        this._client.tezos.setSignerProvider(signer);
        this._client.signer = signer;
    };
    TezosDomainPlugin.prototype.getTezosDomainsClient = function (conn) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, tezos, network;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getTezosClient(conn)];
                    case 1:
                        _a = _b.sent(), tezos = _a.tezos, network = _a.network;
                        tezos.addExtension(new tzip16_1.Tzip16Module());
                        return [2 /*return*/, new taquito_client_1.TaquitoTezosDomainsClient({ tezos: tezos, network: network })];
                }
            });
        });
    };
    TezosDomainPlugin.prototype.getTezosClient = function (conn) {
        return __awaiter(this, void 0, void 0, function () {
            var tezosClient, signer, _a, _b, network;
            var e_2, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // use existing client if connection is not provided
                        if (!conn && this._client) {
                            return [2 /*return*/, this._client];
                        }
                        if (!(conn && conn.provider)) return [3 /*break*/, 3];
                        tezosClient = {
                            tezos: new taquito_1.TezosToolkit(conn.provider),
                            network: conn.network,
                        };
                        if (!conn.secretKey) return [3 /*break*/, 2];
                        return [4 /*yield*/, signer_1.InMemorySigner.fromSecretKey(conn.secretKey)];
                    case 1:
                        signer = _d.sent();
                        tezosClient.signer = signer;
                        _d.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        if (conn) {
                            try {
                                for (_a = __values(Object.keys(this._connections)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    network = _b.value;
                                    if (network === conn.network.toLowerCase()) {
                                        tezosClient = {
                                            tezos: new taquito_1.TezosToolkit(this._connections[network].provider),
                                            network: network,
                                            signer: this._connections[network].signer
                                        };
                                        break;
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        _d.label = 4;
                    case 4:
                        // use default connection if otherwise
                        if (!tezosClient) {
                            tezosClient = {
                                network: TezosDomainPlugin.defaultNetwork,
                                tezos: new taquito_1.TezosToolkit(TezosDomainPlugin.defaultConnection.provider),
                                signer: TezosDomainPlugin.defaultConnection.signer
                            };
                        }
                        this._client = tezosClient;
                        if (this._client.signer) {
                            this.setSigner(this._client.signer);
                        }
                        return [2 /*return*/, this._client];
                }
            });
        });
    };
    TezosDomainPlugin.defaultNetwork = "mainnet";
    TezosDomainPlugin.defaultConnection = {
        provider: "https://rpc.tzstats.com"
    };
    return TezosDomainPlugin;
}(core_js_1.Plugin));
exports.TezosDomainPlugin = TezosDomainPlugin;
var tezosDomainsPlugin = function (opts) {
    return {
        factory: function () { return new TezosDomainPlugin(opts); },
        manifest: w3_1.manifest,
    };
};
exports.tezosDomainsPlugin = tezosDomainsPlugin;
exports.plugin = exports.tezosDomainsPlugin;
//# sourceMappingURL=index.js.map